import { render, staticRenderFns } from "./RecruitmentDecisionPage.vue?vue&type=template&id=7fc1a550&"
import script from "./RecruitmentDecisionPage.vue?vue&type=script&lang=js&"
export * from "./RecruitmentDecisionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports